import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Dispatch, FunctionComponent, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import { Errors } from '../data/Errors';
import { gameConfigStore } from '../store/GameConfigStore';
import { gamePlayStore } from '../store/GameplayStore';
import { settingsStore } from '../store/SettingsStore';
import { storePersistor } from '../store/Store';
import { useDialogAnimation } from '../util/Animation';

type ResetDialogProps = {
	open: boolean;
	onClose: () => unknown;
	setError: Dispatch<SetStateAction<string | undefined>>;
};

export const ResetAppDialog: FunctionComponent<ResetDialogProps> = (props) => {
	const dispatch = useDispatch();
	const { dialogProps } = useDialogAnimation();

	async function handleResetStore() {
		props.onClose();
		props.setError(undefined);

		try {
			// Reset all store slices
			dispatch(gameConfigStore.actions.resetGameConfig());
			dispatch(gamePlayStore.actions.resetGameplay());
			dispatch(settingsStore.actions.resetSettings());

			// Purge persisted state
			await storePersistor.purge();
		} catch (err) {
			if (err instanceof Error) {
				props.setError(err.message);
			} else {
				props.setError('An error occurred while resetting the store');
			}
			Errors.report('An error occurred while resetting the store', err);
		}
	}

	return <Dialog {...props} {...dialogProps}	>
		<DialogTitle>Reset All Data?</DialogTitle>
		<DialogContent>
			<DialogContentText>
				This will completely reset all application data including:
			</DialogContentText>
			<DialogContentText component="ul" sx={{ pl: 2 }}>
				<li>Game configuration and selected game sets</li>
				<li>Current gameplay state and scores</li>
				<li>Application settings</li>
			</DialogContentText>
			<DialogContentText>
				This action cannot be undone. Are you sure you want to continue?
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={() => props.onClose?.()}>
				Cancel
			</Button>
			<Button onClick={handleResetStore} color="error" variant="contained">
				Reset All Data
			</Button>
		</DialogActions>
	</Dialog>;
};